<template>
    <v-card>
        <v-toolbar color="primary" dark> {{ formTitle }}
        </v-toolbar>
        <v-card-title class="text-h5">

        </v-card-title>
        <v-card-text>
            
            <v-row dense>
                <v-col cols="12">
                    <v-autocomplete v-model="data.articulo" :items="getAllProductos" item-text="nombre"
                        item-value="idarticulo" outlined dense label="Producto / Servicio *"></v-autocomplete>
                        <!-- <v-text-field v-model="data.nombre" label="Producto / Servicio *" readonly></v-text-field> -->
                </v-col>
                <v-col cols="12">
                    <v-autocomplete v-model="data.establecimiento" :items="getEstablecimientosActivas"
                        item-text="nombrecomercial" item-value="idestablecimiento" outlined dense
                        label="Establecimiento / bodega *"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="data.stockminimo" label="Stock Minimo *" type="number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="data.stockactual" label="Stock Actual *" type="number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="data.ubicacion" label="Ubicacion" type="text"
                        placeholder="Estante 3, Nivel 5"></v-text-field>
                </v-col>               
            </v-row>
            
        </v-card-text>
        <slot></slot>
    </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2' 
export default {
    name:"CrearEditarExistencia",
    props:[
        "data"
    ],
    data: () => ({
        articulo:0,
        existencias:{
        ubicacion: "",
        stockminimo: 1,
        stockactual: 1000,
        establecimiento: 1
      },
      clearExistencias:{
        ubicacion: "",
        stockminimo: 1,
        stockactual: 1000,
        establecimiento: 1
      }, 
    }),

    async created () {
      await this.initialize()
    },

    computed:{
        ...mapGetters(['getTokenUser','getEstablecimientosActivas','getAllProductos']),
        formTitle () {
            return this.data.idarticulo<1 ? 'Agregar a  Inventario' : 'Editar existencia'
        },
    },

    methods:{
       async initialize(){
        await this.$store.dispatch('setAllEstablecimientos') 

        // const id = parseInt(this.data.id)
        // if(id){
        //     this.existencias = this.data;
        // }
            
        },

        //Crear Existencias
        async postItem(){
        try {
           
          //  this.existencias.articulo = this.data.idarticulo

          await this.$store.dispatch('postExistencias',this.data) 
          Swal.fire('Registro Agregado','','success') 
         // this.initialize()
        } catch (error) {
            console.log(error)
            Swal.fire('Error crear registro','','error') 
        }
      },

      //Actualizar existencias
      async putItem(){
        try {
            this.articulo = this.data.idarticulo
          await this.$store.dispatch('patchExistencias',this.data) 
          
          Swal.fire('Registro Actualizado','','success') 

        } catch (error) {
            console.log(error)
            Swal.fire('Error al actualizar registro','','error') 
        }
          
      }, 

      async save () {
       
            if (this.data.idarticulo> 0) {       
               await  this.putItem()
            } else {
               await this.postItem()
            }
            //this.close()
            this.$emit('setexistencia')
       },


     close () {
            this.dialog = false
            this.$nextTick(() => {
                this.existencias = Object.assign({}, this.clearExistencias)
            })
        },
    }

}
</script>